import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const id = this.element.id;
    const title = this.element.getAttribute("data-title");

    Promise.all([
      import("highcharts/highstock")
    ]).then(res => {
      const [Highcharts] = res;
      Highcharts.chart(id, {
        time: { useUTC: false },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        credits: {
          enabled: false
        },
        title: {
          text: title
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            colors: ["#8BC34A", "#03A9F4", "#FFC107", "#FF9800", "#673AB7", "#9C27B0", "#E91E63", "#009688", "#3F51B5", "#795548"],
            borderColor: null,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || "black"
              }
            },
            animation: false
          }
        },
        series: [
          {
            name: "Percentage Volume",
            colorByPoint: true,
            size: '60%',
            innerSize: '35%',
            data: JSON.parse(this.element.getAttribute("data-stats"))
          }
        ]
      });
    });
  }
}
